// Importación de librerías y módulos
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Header from '../HeaderAdmin';
import { db } from "../../firebase";

// Componente principal
const EventsAdd = () => {
  // Estados iniciales
  const [formValues, setFormValues] = useState({
    url: "",
    fecha: "",
    descripcion: "",
    nombre: "",
    ubicacion: "",
    imagen: null
  });
  const [imageUploaded, setImageUploaded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const navigate = useNavigate(); // hook para redirigir a otras rutas
  const storage = getStorage();
  const productsCollection = collection(db, "eventos");

  // Función que maneja los cambios en el formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Función que maneja los cambios en la imagen

  const handleImagenChange = (e) => {
  const selectedFile = e.target.files[0];
  setFormValues((prev) => ({ ...prev, imagen: selectedFile }));
  setPreviewUrl(URL.createObjectURL(selectedFile));
};

  // Función que se ejecuta al enviar el formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); // indica que se está enviando el formulario
  };

  // Función que sube la imagen a Firebase Storage
  const uploadImage = async () => {
    try {
      const storageRef = ref(storage, formValues.imagen.name);
      const snapshot = await uploadBytes(storageRef, formValues.imagen);
      const url = await getDownloadURL(snapshot.ref);
      setFormValues((prev) => ({ ...prev, url: url }));
      setImageUploaded(true);
    } catch (error) {
      alert(error);
    }
  };

  // Efecto que se ejecuta cuando se termina de enviar el formulario
  useEffect(() => {
    if (submitting && imageUploaded) {
      addDoc(productsCollection, {
        url: formValues.url,
        fecha: formValues.fecha,
        descripcion: formValues.descripcion,
        nombre: formValues.nombre,
        ubicacion: formValues.ubicacion,
      })
        .then(() => {
          console.log("Evento agregado con éxito!");
          navigate("/admin-events"); // redirige al listado de eventos
        })
        .catch((error) => {
          console.error("Error al agregar el evento: ", error);
        })
        .finally(() => {
          setSubmitting(false); // indica que se ha terminado de enviar el formulario
        });
    }
  }, [imageUploaded, submitting, navigate, formValues, productsCollection]);

  // Efecto que se ejecuta al enviar el formulario
  useEffect(() => {
    if (submitting) {
      uploadImage();
    }
  }, [submitting]);

  return (
    <div className="container size">
      <Header/>
      <div className="row">
        <div className="col">
          <h1>Agregar Un Evento Nuevo </h1>
          <form>
            <div className="mb-3">
              <label className="form-label">Nombre</label>
              <input
                value={formValues.nombre}
                onChange={handleChange}
                type="text"
                name="nombre"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Descripcion</label>
              <input
                value={formValues.descripcion}
                onChange={handleChange}
                type="text"
                name="descripcion"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Ubicacion</label>
              <input
                value={formValues.ubicacion}
                onChange={handleChange}
                type="text"
                name="ubicacion"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Fecha</label>
              <input
                value={formValues.fecha}
                onChange={handleChange}
                type="date"
                name="fecha"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Imagen</label>
              <input
                type="file"
                name="imagen"
                onChange={handleImagenChange}
                className="form-control size"
              />
              {previewUrl && <img src={previewUrl} alt="Preview" style={{width:'300px', height:'auto'}}/>}
            </div>

            <div className="btn btn-primary size" onClick={handleSubmit}>Guardar</div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EventsAdd;

